<template>
  <div class="page">
    <section class="section">
      <div class="container">
        <h1 class="title is-h1">
          {{ $texts('login', 'Anmelden') }}
        </h1>
        <div class="columns">
          <div class="column is-one-quarter">
            <UserSidebar />
          </div>
          <div class="column">
            <div class="columns">
              <div class="column is-half">
                <FormsLogin />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
const { $texts } = useNuxtApp()
definePageMeta({
  name: 'login',
  middleware: ['anonymous-only'],
})

useHead({
  title: $texts('login', 'Anmelden'),
})
setBreadcrumbLinks()
await renderPageDependencies()
</script>
